import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import * as moment from 'moment';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { ReportViewerService } from 'src/app/Service/report-viewer.service';

@Component({
  selector: 'app-ventas-por-mes-yclientes',
  templateUrl: './ventas-por-mes-yclientes.component.html',
  styleUrls: ['./ventas-por-mes-yclientes.component.css']
})
export class VentasPorMesYClientesComponent implements OnInit {
  public detfactus: any[] = [];
  public sumacantidad: number = 0;
  public sumapreuni: number = 0;
  public sumatotal: number = 0;
  public pagventas: any = 0;
  public today = new Date();
  public fecinicio: any;
  public fecfin: any;
  public idproducto: any = {nombre:'default'};
  public sucursal: number;
  public meses: string[] = [];
  public clientes: string[] = [];
  public ventas: any = {};
  mesesEnEspañol = {
    January: 'Enero',
    February: 'Febrero',
    March: 'Marzo',
    April: 'Abril',
    May: 'Mayo',
    June: 'Junio',
    July: 'Julio',
    August: 'Agosto',
    September: 'Septiembre',
    October: 'Octubre',
    November: 'Noviembre',
    December: 'Diciembre'
  };

  mesesEnIngles: { [key: string]: string } = this.invertMesesEnEspañol(this.mesesEnEspañol);

  @ViewChild('pagina', null) public pagina: ElementRef;
  producto: any;
  constructor(
      private reportViewer: ReportViewerService,
      private data: DataService,
      private datePipe: DatePipe,
      private cdr: ChangeDetectorRef
    ) { }

  async ngOnInit() {
  }

  printer() {
    const doc = new jsPDF();
    console.log(this.pagina.nativeElement);
    doc.text("Hello world!", 10, 10);
    doc.save("a4.pdf");
  }

  GetData() {
    this.data.GetFromValue('ventasporproduct_mes_clientes', this.idproducto).subscribe(
      async (data) => {
        console.log(data);
        this.clientes = data.clientes;
        this.meses = data.meses.map(mes => this.mesesEnEspañol[mes] || mes);
        this.ventas = data.ventas;
        console.log(this.ventas);
        this.GetProducto()

      },
    (e) => { console.log(e) });
  }

  GetProducto() {
    this.data.GetFromValue(this.data.api.articulos,'idproduct',this.idproducto).subscribe(
      (data) => {
        console.log(data);
        this.producto = data[0]
        this.cdr.detectChanges();
        setTimeout(() => {
          // Generar el PDF
          const blob = this.printerVentas();
          // Mostrar en el modal reutilizable
          if (blob) {
            const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
            this.reportViewer.mostrarPDF(
              blob,
              'Reporte de Ventas a Clientes',
              `reporte_ventas_clientes_${fecha}.pdf`
            );
          }
        }, 0);
        //recien se llama al reporte

      },
    e => { console.log(e) });
  }

  invertMesesEnEspañol(meses: { [key: string]: string }): { [key: string]: string } {
    const inverted: { [key: string]: string } = {};
    for (const [key, value] of Object.entries(meses)) {
      inverted[value] = key;
    }
    return inverted;
  }

  getTotalVentas(cliente: string, mes: string): number {
    const mesEnIngles = this.mesesEnIngles[mes] || mes;
    return this.ventas[cliente] ? this.ventas[cliente][mesEnIngles] || 0 : 0;
  }

  public isbutton: Boolean = true;
  click: boolean = false;
 

  printerVentas() :Blob | null {
    const doc = new jsPDF('l');
    const titulo = { text: 'REPORTE ANUAL', x: 130, y: 20 };


    // Función para agregar encabezado en cada página
    const addHeader = () => {
      doc.setFontSize(14);
      doc.text(titulo.text, titulo.x, titulo.y);
      const textWidth = doc.getTextWidth(titulo.text);  // Obtener el ancho del texto
      const lineY = titulo.y + 1;  // Posición Y de la línea (1 unidad por debajo del texto)

      doc.setLineWidth(0.5);  // Establecer el grosor de la línea
      doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
      doc.setFontSize(11);
      //doc.text(`Del periodo ${this.formatFecha(this.fecinicio, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.fecfin, 'dd-MM-yyyy')}`, 10, 28);
      doc.text(`Articulo: ${this.producto.nombre}`, 10, 28);
      doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 225, 28);
      //doc.addImage(this.empresa.logo, 'PNG', 10, 8, 20, 9);  // Añade tu imagen
      doc.setFontSize(12);
    };

    // Columnas de la tabla

    const tableColumn = ['CLIENTE','ENERO','FEBRERO','MARZO','ABRIL','MAYO','JUNIO','JULIO','AGOSTO','SEPTIEMBRE','OCTUBRE','NOVIEMBRE','DICIEMBRE'];
    const tableRows: any[] = [];

    // Obtener filas de una tabla HTML (ejemplo)
    const rows = document.querySelectorAll('#tabladinamica tbody tr');
    rows.forEach(row => {
      const cols = row.querySelectorAll('td');
      const data: any[] = [];
      cols.forEach(col => data.push(col.innerText));
      tableRows.push(data);
    });

    // Usar autoTable para generar la tabla
    (doc as any).autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 35,
      margin: { horizontal: 10, vertical: 30 },
      theme: 'grid',
      columnStyles: {
        1: { halign: 'center' },
        2: { halign: 'center' },
        3: { halign: 'center' },
        4: { halign: 'center' },
        5: { halign: 'center' },
        6: { halign: 'center' },
        7: { halign: 'center' },
        8: { halign: 'center' },
        9: { halign: 'center' },
        10: { halign: 'center' },
        11: { halign: 'center' },
        12: { halign: 'center' }
        // Alinear la columna "Cantidad" (índice 3) a la derecha
      },
      styles: {
        fontSize: 8,  // Controla el tamaño de fuente para todo el contenido de la tabla
        cellPadding: 1,  // Espaciado interno de las celdas
      },
      didDrawPage: (data: any) => {
        // Encabezado en cada página

        const pageNumber = data.pageNumber;  // Obtener el número de página
        //const pageCount = doc.getNumberOfPages();

        console.log(data.totalPages);

        addHeader();
        const pagetext = `Página ${pageNumber} `;
        doc.text(pagetext, 270, 15);  // Añade tu imagen
      },
      didDrawHeader: (data: any) => {
        doc.setFontSize(10);
        
        doc.text('CLIENTE', data.settings.margin.left, data.cursor.y);
        doc.text('ENERO', data.settings.margin.left, data.cursor.y);
        doc.text('FEBRERO', data.settings.margin.left, data.cursor.y);
        doc.text('MARZO', data.settings.margin.left, data.cursor.y);
        doc.text('ABRIL', data.settings.margin.left, data.cursor.y);
        doc.text('MAYO', data.settings.margin.left, data.cursor.y);
        doc.text('JUNIO', data.settings.margin.left, data.cursor.y);
        doc.text('JULIO', data.settings.margin.left, data.cursor.y);
        doc.text('AGOSTO', data.settings.margin.left, data.cursor.y);
        doc.text('SEPTIEMBRE', data.settings.margin.left, data.cursor.y);
        doc.text('OCTUBRE', data.settings.margin.left, data.cursor.y);
        doc.text('NOVIEMBRE', data.settings.margin.left, data.cursor.y);
        doc.text('DICIEMBRE', data.settings.margin.left, data.cursor.y);
      }
    });

    // Guardar el archivo PDF
    return doc.output('blob');
    
    //doc.save('informe.pdf');

  }

  formatFecha(fecha: Date | string, format: string): string {
    // Formatear la fecha a 'dd-MM-yyyy'
    return this.datePipe.transform(fecha, format) || '';
  }


  back() {
    //this.router.navigateByUrl("/");
    window.history.back();
  }

}
